import React from 'react';
import PropTypes from 'prop-types';

import { DetailCell } from './styled';

const VehiclePlateNumber = ({ plate_number, className, ...props }) => (
  <DetailCell className={className} {...props}>
    {plate_number}
  </DetailCell>
);

VehiclePlateNumber.propTypes = {
  plate_number: PropTypes.string,
  className: PropTypes.string,
};

export default VehiclePlateNumber;
